<mat-card appearance="outlined">
  <ng-container *ngIf="!ready">
    <div class="row">
      <div class="col">
        <p class="text-center">
          <strong>¿Quieres convertirlo en factura?</strong>
        </p>
        <br />

        <div class="d-flex justify-content-center flex-column flex-md-row">
          <ng-container *ngIf="error == false && canPublishDeliveryNoteFifteenDays === true">
            <button mat-stroked-button (click)="convertToInvoiceFifteenDays()" class="me-0 me-md-2 mb-2 mb-md-0">
              Convertir a factura mes anterior
            </button>
          </ng-container>
          <ng-container *ngIf="error == false">
            <button mat-stroked-button (click)="convertToInvoice()" class="me-0 me-md-2 mb-2 mb-md-0">
              Convertir a factura
              <span *ngIf="error == false && canPublishDeliveryNoteFifteenDays === true">mes vigente</span>
            </button>
          </ng-container>
          <button mat-stroked-button (click)="closeDialog()">
            <mat-icon>close</mat-icon>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="ready">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </ng-container>
</mat-card>
